var React = require('react');

function YoutubeIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 0.303711C0.1376 0.303711 0 1.00291 0 6.46371C0 11.9245 0.1376 12.6237 8 12.6237C15.8624 12.6237 16 11.9245 16 6.46371C16 1.00291 15.8624 0.303711 8 0.303711ZM10.564 6.73091L6.972 8.40771C6.6576 8.55331 6.4 8.39011 6.4 8.04291V4.88451C6.4 4.53811 6.6576 4.37411 6.972 4.51971L10.564 6.19651C10.8784 6.34371 10.8784 6.58371 10.564 6.73091Z","fill":"#B3001B"}));
}

YoutubeIcon.defaultProps = {"width":"16","height":"13","viewBox":"0 0 16 13","fill":"none"};

module.exports = YoutubeIcon;

YoutubeIcon.default = YoutubeIcon;
